// extracted by mini-css-extract-plugin
export default {"message":"styles_message__VGQh+","datePickerWrapper":"styles_datePickerWrapper__L5Eid","lossAmountWrapper":"styles_lossAmountWrapper__uzOK0"};